export const visitBanner = {
  title: "¡No te quedes con dudas!",
  description: "Reserva tu visita el día y hora que quieras y descubre cómo funcionamos.",
  button: "Reservar visita"
};
